import { Link } from "react-router-dom";
import SEO, { breadcrumbLd } from "./SEO";
import { FadeUp, MaskLine } from "./Reveal";

export default function PageHero({ seo, crumbs = [], eyebrow, title, titleEm, copy, light = false, children }) {
    return (
        <section
            className={
                light
                    ? "bg-ivory pb-16 pt-[76px] text-navy-deep lg:pb-20"
                    : "relative overflow-hidden bg-navy-deep pb-16 pt-[76px] lg:pb-20"
            }
        >
            <SEO {...seo} jsonLd={[seo?.jsonLd, crumbs.length ? breadcrumbLd([{ label: "Home", href: "/" }, ...crumbs]) : null]} />
            {!light && <div className="hero-grid pointer-events-none absolute inset-0" aria-hidden="true" />}
            <div className="relative mx-auto max-w-[1440px] px-5 pt-10 lg:px-10 lg:pt-14">
                {crumbs.length > 0 && (
                    <nav aria-label="Breadcrumb" className="mb-9 flex flex-wrap items-center gap-2.5 text-[10px] font-semibold uppercase tracking-[0.22em]">
                        <Link to="/" className={`transition-colors ${light ? "text-navy-deep/45 hover:text-gold" : "text-slate-500 hover:text-gold"}`}>
                            Home
                        </Link>
                        {crumbs.map((c, i) => (
                            <span key={i} className="flex items-center gap-2.5">
                                <span className="text-gold/50" aria-hidden="true">/</span>
                                {c.href ? (
                                    <Link to={c.href} className={`transition-colors ${light ? "text-navy-deep/45 hover:text-gold" : "text-slate-500 hover:text-gold"}`}>
                                        {c.label}
                                    </Link>
                                ) : (
                                    <span className={light ? "text-navy-deep/80" : "text-slate-300"}>{c.label}</span>
                                )}
                            </span>
                        ))}
                    </nav>
                )}
                <FadeUp>
                    <div className="flex items-center gap-4">
                        <span className="h-px w-12 bg-gold" aria-hidden="true" />
                        <span className="text-[11px] font-semibold uppercase tracking-[0.34em] text-gold sm:text-xs">
                            {eyebrow}
                        </span>
                    </div>
                </FadeUp>
                <h1
                    className={`mt-7 font-serif text-4xl font-light leading-[1.06] tracking-tight sm:text-5xl lg:text-6xl ${
                        light ? "text-navy-deep" : "text-ivory"
                    }`}
                >
                    <MaskLine delay={0.15}>
                        <span>
                            {title} {titleEm && <em className="font-medium italic text-gold">{titleEm}</em>}
                        </span>
                    </MaskLine>
                </h1>
                {copy && (
                    <FadeUp delay={0.3}>
                        <p className={`mt-6 max-w-2xl text-base leading-relaxed md:text-lg ${light ? "text-navy-deep/70" : "text-slate-300/85"}`}>
                            {copy}
                        </p>
                    </FadeUp>
                )}
                {children}
            </div>
        </section>
    );
}
